export default {"src":"/_next/static/media/frontend.da5e0a11.svg","height":32,"width":32,"blurWidth":0,"blurHeight":0};